import React  from "react";
import { useParams } from 'react-router-dom';
import OvertimeForm from "./components/OvertimeForm";
import Card from "components/card";

const ViewOvertime = () => {
	const { overtimeId } = useParams();
    
	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					<OvertimeForm recordId={overtimeId} mode="edit"/>
				</Card>
	      	</div>
	    </div>
    );
};

export default ViewOvertime;